/**
 * Image Gallery — click-to-enlarge lightbox
 * Vanilla JS, no dependencies. Supports multiple gallery sections on one page.
 */
(function () {
  'use strict';

  function initGallery(section) {
    var lightbox = section.parentElement
      ? section.parentElement.querySelector('[data-gallery-lightbox]')
      : null;

    // Lightbox markup is a sibling of the section, output right after it.
    if (!lightbox) {
      lightbox = section.nextElementSibling;
      if (!lightbox || !lightbox.hasAttribute('data-gallery-lightbox')) return;
    }

    var triggers = Array.prototype.slice.call(
      section.querySelectorAll('[data-gallery-trigger]')
    );
    if (!triggers.length) return;

    var imageEl = lightbox.querySelector('[data-gallery-lightbox-image]');
    var captionEl = lightbox.querySelector('[data-gallery-lightbox-caption]');
    var closeBtn = lightbox.querySelector('[data-gallery-close]');
    var prevBtn = lightbox.querySelector('[data-gallery-prev]');
    var nextBtn = lightbox.querySelector('[data-gallery-next]');

    var currentIndex = 0;
    var lastFocusedTrigger = null;

    function openAt(index) {
      currentIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[currentIndex];
      var fullSrc = trigger.getAttribute('data-full-src');
      var caption = trigger.getAttribute('data-caption') || '';

      imageEl.src = fullSrc;
      imageEl.alt = caption;
      captionEl.textContent = caption;
      captionEl.hidden = caption.length === 0;

      lastFocusedTrigger = trigger;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();

      var multi = triggers.length > 1;
      prevBtn.style.display = multi ? '' : 'none';
      nextBtn.style.display = multi ? '' : 'none';
    }

    function close() {
      lightbox.hidden = true;
      imageEl.src = '';
      document.body.style.overflow = '';
      if (lastFocusedTrigger) lastFocusedTrigger.focus();
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openAt(index);
      });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () {
      openAt(currentIndex - 1);
    });
    nextBtn.addEventListener('click', function () {
      openAt(currentIndex + 1);
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') openAt(currentIndex - 1);
      if (event.key === 'ArrowRight') openAt(currentIndex + 1);
    });
  }

  function initAllGalleries() {
    var sections = document.querySelectorAll('.gallery-section');
    sections.forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  // Re-init when a gallery section is added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.gallery-section');
    if (section) initGallery(section);
  });
})();